// OFX/QFX is SGML, not XML — older files leave leaf tags unclosed
// (e.g. <TRNTYPE>DEBIT with no </TRNTYPE>), so a real XML parser will
// choke on them. Container tags like <STMTTRN> are always closed, so we
// split on those and then pull each leaf value up to the next "<".

const getTag = (block, tag) => {
  const m = block.match(new RegExp(`<${tag}>([^<\r\n]*)`, 'i'));
  return m ? m[1].trim() : '';
};

const parseOfxDate = (raw) => {
  const digits = raw.replace(/\D/g, '').slice(0, 8); // YYYYMMDD
  if (digits.length < 8) return '';
  return `${digits.slice(0, 4)}-${digits.slice(4, 6)}-${digits.slice(6, 8)}`;
};

// Returns [{ fitId, date, amount, name, memo, checkNum, trnType }]
export const parseOfx = (text) => {
  const blocks = text.match(/<STMTTRN>[\s\S]*?<\/STMTTRN>/gi) || [];

  return blocks
    .map((block) => ({
      fitId:    getTag(block, 'FITID'),
      date:     parseOfxDate(getTag(block, 'DTPOSTED')),
      amount:   parseFloat(getTag(block, 'TRNAMT')) || 0,
      name:     getTag(block, 'NAME') || getTag(block, 'PAYEE'),
      memo:     getTag(block, 'MEMO'),
      checkNum: getTag(block, 'CHECKNUM'),
      trnType:  getTag(block, 'TRNTYPE'),
    }))
    .filter((r) => r.date && r.amount !== 0);
};
